import React from 'react';
import PropTypes from 'prop-types';
import { Line, Label, Value } from './styles';

export default function LineInfo({ label, value }) {
  return (
    <Line>
      <Label>{ label }</Label>
      <Value>{ value }</Value>
    </Line>
  )
}

LineInfo.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
}

LineInfo.defaultProps = {
  value: '---',
}
